import { defineMessages } from 'react-intl';

export default defineMessages({
  tableTitle: {
    id: 'specialClaims.tableTitle',
    defaultMessage: 'Special Claims',
  },
  status: {
    id: 'specialClaims.status',
    defaultMessage: 'Status',
  },
  claimType: {
    id: 'specialClaims.claimType',
    defaultMessage: 'Claim Type',
  },
  claimId: {
    id: 'specialClaims.claimId',
    defaultMessage: 'Claim ID',
  },
  requestedAmount: {
    id: 'specialClaims.requestedAmount',
    defaultMessage: 'Requested Amount',
  },
  approvedAmount: {
    id: 'specialClaims.approvedAmount',
    defaultMessage: 'Approved Amount',
  },
  chargeCode: {
    id: 'specialClaims.chargeCode',
    defaultMessage: 'Charge Code',
  },
  actions: {
    id: 'specialClaims.actions',
    defaultMessage: 'Actions',
  },
  addNew: {
    id: 'specialClaims.addNew',
    defaultMessage: 'Add New',
  },
  delete: {
    id: 'specialClaims.delete',
    defaultMessage: 'Delete',
  },
  emptyStateMessage: {
    id: 'specialClaims.emptyStateMessage',
    defaultMessage: 'No special claims found',
  },
  loadError: {
    id: 'specialClaims.loadError',
    defaultMessage: 'Unable to load special claims.',
  },
  loadChargeCodesError: {
    id: 'specialClaims.loadChargeCodesError',
    defaultMessage: 'Unable to load charge codes.',
  },
  createSuccess: {
    id: 'specialClaims.createSuccess',
    defaultMessage: 'Special claim created.',
  },
  createError: {
    id: 'specialClaims.createError',
    defaultMessage: 'Unable to create special claim.',
  },
  createDuplicateHudClaimIdError: {
    id: 'specialClaims.createDuplicateHudClaimIdError',
    defaultMessage:
      'A Special Claim with this Claim ID already exits. Please use a Claim ID that is not already used ' +
      'in the voucher.',
  },
  deleteSuccess: {
    id: 'specialClaims.deleteSuccess',
    defaultMessage: 'Special claim deleted.',
  },
  deleteError: {
    id: 'specialClaims.deleteError',
    defaultMessage: 'Unable to delete special claim.',
  },
  voucherStatusUpdatedTitle: {
    id: 'specialClaims.voucherStatusUpdatedTitle',
    defaultMessage: 'Voucher Status Updated',
  },
  voucherReturnedToDraftWarning: {
    id: 'specialClaims.voucherReturnedToDraftWarning',
    defaultMessage:
      'The voucher has been returned to Draft status. A new submission will be required.',
  },
  deleteMissingIdError: {
    id: 'specialClaims.deleteMissingIdError',
    defaultMessage: 'Unable to delete: Special claim ID is missing.',
  },
  deletePaidError: {
    id: 'specialClaims.deletePaidError',
    defaultMessage:
      'Cannot delete special claims from vouchers that have been paid.',
  },
  deleteNotFoundError: {
    id: 'specialClaims.deleteNotFoundError',
    defaultMessage: 'Special claim not found.',
  },
  deleteFeatureUnavailableError: {
    id: 'specialClaims.deleteFeatureUnavailableError',
    defaultMessage:
      'This feature is not available. Please contact your administrator.',
  },
  updateApprovedAmountError: {
    id: 'specialClaims.updateApprovedAmountError',
    defaultMessage: 'Unable to update approved amount. Please try again.',
  },
  updateApprovedAmountSuccess: {
    id: 'specialClaims.updateApprovedAmountSuccess',
    defaultMessage: 'Approved amount updated successfully.',
  },
});
